import { render, staticRenderFns } from "./OpenBillingInvoiceForm.vue?vue&type=template&id=4f55f47c&scoped=true&"
import script from "./OpenBillingInvoiceForm.vue?vue&type=script&lang=js&"
export * from "./OpenBillingInvoiceForm.vue?vue&type=script&lang=js&"
import style0 from "./OpenBillingInvoiceForm.vue?vue&type=style&index=0&id=4f55f47c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f55f47c",
  null
  
)

export default component.exports